import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { SET_ONLINE, SET_PREVENT_ACTION_ON_OFFLINE } from './actionTypes';
/**
 * Access connectivity data from the store by reducing the whole store of data down to just the connectivity slice of data
 *
 * @param {Object} [state={}] The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The connectivity data
 */

var connectivityReducer = function connectivityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    online: true,
    preventActionOnOffline: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type === SET_ONLINE) {
    return _Object$assign({}, state, {
      online: action.payload
    });
  }

  if (action.type === SET_PREVENT_ACTION_ON_OFFLINE) {
    return _Object$assign({}, state, {
      preventActionOnOffline: action.payload
    });
  }

  return _Object$assign({}, state);
};

export default {
  connectivityReducer: connectivityReducer
};